module.exports = __webpack_public_path__ + "static/media/gold-icon.45ffee3c.png";